ValorisationStocksFiltresValidator.$inject = ['validator'];

export default function ValorisationStocksFiltresValidator(validator) {
	const instance = new validator();

	instance.ruleFor('idGrpSite').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('idDebutPeriode').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('idFinPeriode').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('eltNiv1').notEmpty().withMessage('VALIDATION_NOTEMPTY');

	return instance;
}
